export default {
  "AgreementCardTitle.Title":
    "Consents regarding the handling of Personal Data",
  "AgreementCardTitle.Description":
    "Please agree to the following terms and conditions when applying for {name}",
}
